<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <template v-if="openedInModal">
        <UserDataEmployeeForm
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
      </template>
      <template v-else>
        <b-row>
          <b-col>
            <router-link :to="{ name: 'FirmList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">{{$t('views.firm.create.title')}}</h4>
              </div>
              <div class="card-body">
                <b-row>
                  <b-col>
                    <UserDataEmployeeForm
                            :handle-submit="onSendForm"
                            :handle-update-field="updateField"
                            :values="item"
                            :errors="violations" />
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import UserDataEmployeeForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('userdataemployee/create')

export default {
  components: {
    UserDataEmployeeForm,
    Loader
  },

  props: {
    firmIRI: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      routeName: '',
      item: {
        isContactPerson: 0,
        vatInvoiceRecipient: 0,
        employeePosition: '',
        caseTypesAllowedForNotification: []
      }
    }
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ]),
    openedInModal: function (val) {
      if (this.routeName === 'FirmShow') {
        return true
      } else {
        return false
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    if (this.firmIRI) {
      this.item.firm = this.firmIRI
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.openedInModal) {
        this.$store.state.modals.userdataemployee.create.created = 1
        this.$store.state.modals.userdataemployee.create.close = 1
      } else {
        this.$router.push({ name: 'UserDataEmployeeShow', params: { id: created['@id'] } })
      }
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
